import styled, { css } from "styled-components";
import { TextField, Button } from "@mui/material";
import { Edit, Save } from "@mui/icons-material";

import mapOverlay from "assets/common/mapOverlay.png";

export const Container = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  padding: 25px;
  width: 504px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const MapContainer = styled.div<{ shouldRenderOverlay: boolean }>`
  margin-top: 25px;
  height: 300px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  position: relative;
  align-items: center;
  display: flex;

  ${({ shouldRenderOverlay, theme }) =>
    shouldRenderOverlay &&
    css`
      &::before {
        content: "";
        position: absolute;
        border-radius: ${theme.shape.borderRadius}px;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${mapOverlay});
        filter: brightness(30%);
      }
    `}
`;

export const MapContent = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const Map = styled.div`
  width: 100%;
  height: 100%;
  z-index: 5;

  .gm-svpc {
    height: 37px !important;
  }

  .gm-svpc img {
    height: 23px !important;
    width: 23px !important;
  }

  .gmnoprint > div {
    border-radius: 25px !important;
    width: 37px !important;
  }

  .gmnoprint > div > button {
    width: 37px !important;
  }

  .gmnoprint > div > button > img {
    height: 12px !important;
    width: 12px !important;
  }
`;

export const MiddleActionsContainer = styled.div`
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const TypeLinkContainer = styled.form`
  margin-left: 15px;
  width: 424px;
  padding: 8px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background: ${({ theme }) => theme.palette.background.paper};
  z-index: 10;
`;

export const TypeLinkTextField = styled(TextField)`
  margin-top: 15px !important;
`;

export const ActionsContainer = styled.div`
  margin-top: 15px;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  display: flex;
`;

export const ActionContainer = styled(Button)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    background-color: transparent !important;
  }
`;

export const EditIcon = styled(Edit)`
  margin-left: 8px;
`;

export const SaveIcon = styled(Save)`
  margin-left: 8px;
`;

export const Link = styled.a`
  text-decoration: none;
  color: rgba(0, 0, 0, 05);
`;

export const ButtonMap = styled.button`
  display: flex;
  background: none;
  justify-content: start;
  align-items: center;
  width: 100%;
  border: 0;
  margin-top: 20px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  gap: 6px;
`;
